module.exports = __webpack_public_path__ + "img/cuisine.43420d82.jpg";